<template>
    <a-modal v-model="visible" title="批量导入会员" @ok="handleOk" @cancel="handleClose" :confirmLoading="confirmLoading"
        :maskClosable="false">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
            <a-form-model-item label="会员数据文件">
                <!-- <div class="imgcontainer" @dragover.prevent="onDragOver" @drop.prevent="onDrop"
                    :style="{ width: form.imageWidth + 'px', height: form.imageWidth + 'px' }">
                    <a-icon type="upload" style="font-size: 24px;margin-bottom: 2px;" />
                    <div style="font-size: 12px;color: #666;">拖拽至此上传</div>
                </div> -->
                <a-upload-dragger class="imgcontainer" name="file" :multiple="false" :showUploadList="false"
                    :customRequest="onDrop">
                    <p class="ant-upload-drag-icon" style="margin: 0;">
                        <a-icon type="inbox" />
                    </p>
                    <p class="ant-upload-hint">点击或拖拽至此上传</p>
                </a-upload-dragger>
            </a-form-model-item>
            <a-form-model-item label="结果" prop="datas">
                已读取到{{ form.datas.length }}条数据
            </a-form-model-item>
            <a-form-model-item label="未匹配处理" prop="area">
                <a-switch v-model="form.area" checked-children="是" un-checked-children="否"></a-switch>
                <div style="margin-top: -10px;">是否将未匹配到客服的客户，转入公海</div>
            </a-form-model-item>

            <a-form-model-item label="导入模板" prop="area">
                <a-button @click="downloadTemplate">点击下载导入模板文件</a-button>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import * as XLSX from "xlsx";
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: {
                datas: [],
                area: true
            },
            submitLoading: false,
            rules: {
                datas: [
                    {
                        required: true,
                        message: "请选择导入文件上传",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        init(costomer_id) {
            this.form.costomer_id = costomer_id;
            this.visible = true;
        },
        downloadTemplate() {
            const link = document.createElement("a");
            link.href = "/导入模板.xlsx"; // 静态文件路径
            link.download = "导入模板.xlsx"; // 下载文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // 阻止默认行为，使文件可以拖拽进来
        onDragOver(event) {
            event.preventDefault();
        },
        // 处理文件拖放
        onDrop(event) {
            const file = event.file
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // 读取第一个工作表
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // 将 Excel 数据转换为 JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                const excelData = jsonData.slice(1).filter(v => v.length > 0).filter(v => !!v[3]).map(v => {
                    const f = v[0]
                    const first_jointime = (typeof f === 'number' && f > 0) ? this.excelSerialToDate(f) : null
                    return {
                        first_jointime: first_jointime,
                        customer_name: v[1],
                        gender: v[2] == '男' ? '1' : v[2] == '女' ? '2' : null,
                        customer_phone: v[3],
                        id_no: v[4],
                        wechart_account: v[5],
                        vip_price: v[6],
                        vip: v[7],
                        customer_address: v[8],
                        first_joinuser: v[9]
                    }
                })
                console.log(JSON.parse(JSON.stringify(excelData)))
                this.form.datas = excelData
                this.$refs.ruleForm.validateField("datas")
            };
        },
        formatExcelCell(cell) {
            if (typeof cell === "number" && cell > 50 && cell < 50000) {
                // 可能是 Excel 的日期格式
                return this.excelSerialToDate(cell);
            }
            return cell;
        },
        excelSerialToDate(serial) {
            const utc_days = serial - 25569;
            const utc_value = utc_days * 86400;
            const date = new Date(utc_value * 1000);
            console.log(date.toISOString().split("T")[0])
            return date.toISOString().split("T")[0]; // 返回 YYYY-MM-DD 格式
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: "/admin/customer/piliang",
                        method: "post",
                        data: this.form,
                    })
                        .then(() => {
                            this.$message.success("操作成功");
                            // this.handleClose();
                            this.$emit("ok");
                            this.$refs.ruleForm.resetFields();
                        })
                        .finally(() => (this.confirmLoading = false));
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.$refs.ruleForm.resetFields();
            this.visible = false;
        },
    },
};
</script>

<style scoped lang="scss"></style>